import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { BiExport } from 'react-icons/bi';
import { Table, Panel, IconButton, Stack, Tag, SelectPicker, Badge } from 'rsuite';
import * as XLSX from 'xlsx';
import { Dia } from 'rsuite';
import { confirm } from '@rsuite/interactions';
import { useAppSelector } from '@/config/hooks';
import { getCurrencies } from '@/services/mission.service';
import { useTranslation } from 'react-i18next';

const { Column, ColumnGroup, HeaderCell, Cell } = Table;

const DataTable = props => {
  const { title, data } = props;

  const [currencies, setCurrencies] = useState([]);

  const [filterMissionTag, setFilterMissionTag] = useState('');
  const loading = useAppSelector((state: any) => state.dashboard.loading);
  const { t } = useTranslation();
  const options = [
    { label: t('All'), value: '' },
    { label: t('Departure'), value: 'departure' },
    { label: t('Ongoing'), value: 'ongoing' },
    { label: t('Return'), value: 'returning' },
    { label: t('Departure-Return'), value: 'departure_and_return' },
    { label: t('Ended'), value: 'ended' }
  ];

  useEffect(() => {
    const fetchData = async () => {
      const resCurrencies = await getCurrencies();
      setCurrencies(resCurrencies);
    };
    fetchData();
  }, []);

  const handleFilterChange = event => {
    setFilterMissionTag(event);
  };

  const filteredData = data.filter(
    item => filterMissionTag === '' || item.missionTag === filterMissionTag
  );

  async function Download() {
    const formattedData = await Promise.all(
      groupedData.map(async rowData => {
        const row = {};

        row['ID Folder'] = `${rowData.requestId}`;
        row['Full name'] = `${rowData.firstname} ${rowData.lastname}`;
        row['GPN'] = rowData.gpn;
        row['Engagement code'] = rowData.engagementCode || rowData.statusEngagementCode;
        row['Departure date'] = rowData.startDate
          ? format(new Date(rowData.startDate), 'dd-MM-yyyy')
          : '';
        row['Arrival date'] = rowData.endDate
          ? format(new Date(rowData.endDate), 'dd-MM-yyyy')
          : '';
        row['Title'] = rowData.title;
        row['Country'] = rowData.country?.name;
        row['City'] = rowData?.city?.name;
        row['Status'] = rowData.missionTag;

        await rowData.allTransportationCosts.forEach(item => {
          if (item.currency && item.cost) {
            const id = item.currencyId?._id || item.currency;
            const currency = currencies.find(curr => curr._id == id)?.name;

            const costItem = item;
            const cost =
              rowData.missionType == 'compound' &&
              costItem &&
              costItem.mission == rowData.subMissionId
                ? `${costItem.cost} ${currency.name || ''}`
                : costItem && !costItem.mission
                ? `${costItem.cost} ${currency.name || ''}`
                : '-';
            row[`${item.type || item.comment}`] = cost;
          }
        });
        row[`Company`] = rowData.companies?.length
          ? rowData.companies
              .map(company => company?.name)
              .filter(Boolean)
              .join(', ')
          : '-';
        row[`Class`] = rowData?.allTransportationCosts.length
          ? rowData.allTransportationCosts
              .map(item => item?.class)
              .filter(Boolean)
              .join(', ')
          : '-';
        await rowData.transportationCosts.forEach(({ currencyId, cost }) => {
          if (currencyId && cost) {
            const id = currencyId?._id || currencyId;
            const currency = currencies.find(curr => curr._id == id)?.name;
            row[`Calculated transport cost in ${currency}`] = cost;
          }
        });

        await rowData.stayCosts.forEach(({ currencyId, cost }) => {
          if (currencyId && cost) {
            const id = currencyId?._id || currencyId;
            const currency = currencies.find(curr => curr._id == id)?.name;
            row[`Calculated accomodation cost in ${currency}`] = cost;
          }
        });

        await rowData.stayEstimated.forEach(({ currencyId, cost }) => {
          if (currencyId && cost) {
            const id = currencyId?._id || currencyId;
            const currency = currencies.find(curr => curr._id == id)?.name;
            row[`Estimated accomodation cost in ${currency}`] = cost;
          }
        });

        await rowData.otherAccomodationCosts.forEach(({ currencyId, cost }) => {
          if (currencyId && cost) {
            const id = currencyId?._id || currencyId;
            const currency = currencies.find(curr => curr._id == id)?.name;
            row[`Calculated other Accomodation cost ${currency}`] = cost;
          }
        });
        await rowData.perdiems.forEach(({ currencyId, cost }) => {
          if (currencyId && cost) {
            const id = currencyId?._id || currencyId;
            const currency = currencies.find(curr => curr._id == id)?.name;
            row[`Calculated Per Diem cost in ${currency}`] = cost;
          }
        });

        await rowData.perdiemsEstimated.forEach(({ currencyId, cost }) => {
          if (currencyId && cost) {
            const id = currencyId?._id || currencyId;
            const currency = currencies.find(curr => curr._id == id)?.name;
            row[`Estimated Per Diem cost in ${currency}`] = cost;
          }
        });

        row[
          `Extra expenses cost in ${currencies?.find(c => c.name === 'EUR')?.name}`
        ] = `${rowData.extraExpensesSum} `;
        row[`Total invoices in EUR`] = `${rowData.billsCount?.total}`;
        row[`Uploaded invoices in EUR`] = `${rowData.billsCount?.uploaded} `;
        row[`Total invoices in TND`] = `${rowData.invoicesCount?.total}`;
        row[`Uploaded invoices in TND`] = `${rowData.invoicesCount?.uploaded}`;
        return row;
        // return {
        //   'ID Folder': `${rowData.requestId}`,
        //   'Full name': rowData.firstname + ' ' + rowData.lastname,
        //   GPN: rowData.gpn,
        //   'Engagement code': rowData.engagementCode || rowData.statusEngagementCode,
        //   'Departure date': rowData.startDate
        //     ? format(new Date(rowData.startDate), 'dd-MM-yyyy')
        //     : '',
        //   'Arrival date': rowData.endDate ? format(new Date(rowData.endDate), 'dd-MM-yyyy') : '',
        //   Title: rowData.title,
        //   Country: rowData.country?.name,
        //   City: rowData?.city?.name,
        //   Status:
        //     rowData.missionTag == 'departure'
        //       ? 'Departure'
        //       : rowData.missionTag == 'returning'
        //       ? 'Return'
        //       : rowData.missionTag == 'ongoing'
        //       ? 'Ongoing'
        //       : rowData.missionTag == 'ended'
        //       ? 'Ended'
        //       : rowData.missionTag == 'departure_and_return'
        //       ? 'Departure-Return'
        //       : rowData.missionTag,

        //   ...row
        // };
      })
    );

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, `Extract.xlsx`);
  }

  const handleRowClick = async (rowData, event) => {
    event.stopPropagation();
    const options = { okButtonText: 'Yes', cancelButtonText: 'Cancel' };
    const result = await confirm("Are you sure you want to access the mission's folder ?", options);

    if (result) {
      window.location.href = `/admin/mission/${rowData.requestId}`;
    }
  };

  const getColorGenerator = () => {
    const usedColors = new Set();

    const generateColor = () => {
      let color;
      do {
        color = `#${Math.floor(Math.random() * 16777215).toString(16)}`; // Couleur hex aléatoire
      } while (usedColors.has(color)); // Vérifie si la couleur a déjà été utilisée
      usedColors.add(color);
      return color;
    };

    const colorMap = {};
    return requestId => {
      if (!colorMap[requestId]) {
        colorMap[requestId] = generateColor();
      }
      return colorMap[requestId];
    };
  };

  const getBadgeColor = getColorGenerator();

  const groupedData = filteredData.map((row, index) => ({
    ...row,
    color: getBadgeColor(row.requestId)
  }));

  const currenciesTransport = Array.from(
    new Set(
      groupedData.flatMap(row =>
        row.transportationCosts.map(cost => cost.currencyId?._id || cost.currencyId)
      )
    )
  );

  // const maxColumns = Math.max(
  //   ...groupedData.map(item => item.allTransportationCosts?.length || 0),
  //   0
  // );
  // console.log('maxElements', maxColumns);

  const transportTypeCosts = Array.from(
    new Set(
      groupedData.flatMap(row => row.allTransportationCosts.map(cost => cost.type || cost.comment))
    )
  );

  const currenciesStay = Array.from(
    new Set(
      groupedData.flatMap(row => row.stayCosts.map(cost => cost.currencyId?._id || cost.currencyId))
    )
  );

  const currenciesStayEstimated = Array.from(
    new Set(
      groupedData.flatMap(row =>
        row.stayEstimated.map(cost => cost.currencyId?._id || cost.currencyId)
      )
    )
  );

  // const currenciesStay = Array.from(
  //   new Set(
  //     groupedData.flatMap(row =>
  //       row.stayCosts
  //         .map(cost => ({ currencyId: cost.currencyId, isEstimated: false })) // Réel
  //         .concat(
  //           row.stayEstimated.map(est => ({ currencyId: est.currencyId, isEstimated: true })) // Estimé
  //         )
  //     )
  //   )
  // );

  const currenciesOtherAccomodation = Array.from(
    new Set(
      groupedData.flatMap(row =>
        row.otherAccomodationCosts.map(cost => cost.currencyId?._id || cost.currencyId)
      )
    )
  );
  const currenciesPerdiems = Array.from(
    new Set(
      groupedData.flatMap(row => row.perdiems.map(cost => cost.currencyId?._id || cost.currencyId))
    )
  );

  const currenciesPerdiemsEstimated = Array.from(
    new Set(
      groupedData.flatMap(row =>
        row.perdiemsEstimated.map(cost => cost.currencyId?._id || cost.currencyId)
      )
    )
  );

  return (
    <>
      <Panel
        className="card mt-20"
        header={
          <Stack justifyContent="space-between">
            <p>{title}</p>
            <IconButton title={t("Extract")} icon={<BiExport />} onClick={Download} />
          </Stack>
        }
      >
        <SelectPicker
          value={filterMissionTag}
          onChange={handleFilterChange}
          data={options}
          style={{ width: 224 }}
          onClean={() => setFilterMissionTag('')}
        />

        <Table
          height={500}
          // data={filteredData}
          data={groupedData}
          rowKey="_id"
          className="mt-10"
          loading={loading}
          onRowClick={handleRowClick}
          headerHeight={80}
          cellBordered
          bordered
        >
          <Column width={220} align="center" fixed="left">
            <HeaderCell>{t('ID Folder')}</HeaderCell>
            <Cell>
              {rowData => (
                <Stack spacing={10}>
                  <Badge
                    style={{ backgroundColor: rowData.color, color: '#fff' }}
                    // content={rowData.requestId}
                  ></Badge>
                  {rowData.requestId}
                </Stack>
              )}
            </Cell>
          </Column>
          <Column width={100} resizable>
            <HeaderCell>{t('Full name')} </HeaderCell>
            <Cell>
              {rowData => {
                return <p>{rowData.firstname + ' ' + rowData.lastname}</p>;
              }}
            </Cell>
          </Column>
          <Column width={130} resizable>
            <HeaderCell>{t('GPN')}</HeaderCell>
            <Cell dataKey="gpn" />
          </Column>
          <Column width={130} resizable>
            <HeaderCell>{t('Engagement code')}</HeaderCell>
            <Cell>
              {rowData => <p>{rowData.engagementCode || rowData.statusEngagementCode}</p>}
            </Cell>
          </Column>

          <Column width={130} resizable>
            <HeaderCell>{t('Start date')}</HeaderCell>
            <Cell>
              {rowData => {
                return (
                  <p>
                    {rowData.startDate ? format(new Date(rowData.startDate), 'dd-MM-yyyy') : ''}
                  </p>
                );
              }}
            </Cell>
          </Column>

          <Column width={100} resizable>
            <HeaderCell>{t('End date')}</HeaderCell>
            <Cell>
              {rowData => {
                return (
                  <p>{rowData.endDate ? format(new Date(rowData.endDate), 'dd-MM-yyyy') : ''}</p>
                );
              }}
            </Cell>
          </Column>
          <Column width={220} resizable>
            <HeaderCell>{t('Title')}</HeaderCell>
            <Cell dataKey="title" />

            {/* <Cell>
              {rowData => {
                return rowData.missionType && rowData.missionType == 'compound'
                  ? rowData.missions.map(item => item.title + ' ')
                  : rowData.title;
              }}
            </Cell> */}
          </Column>
          <Column width={250} resizable>
            <HeaderCell>{t('Country')}</HeaderCell>
            <Cell>
              {rowData => {
                return <p>{rowData.country?.name}</p>;
              }}
            </Cell>
          </Column>
          <Column width={200} resizable>
            <HeaderCell>{t('City')}</HeaderCell>
            <Cell>
              {rowData => {
                return <p>{rowData?.city?.name}</p>;
              }}
            </Cell>
          </Column>
          <Column width={150} resizable>
            <HeaderCell>{t('Status')}</HeaderCell>
            <Cell>
              {rowData => {
                return (
                  <Tag
                    color={`${
                      rowData.missionTag == 'departure'
                        ? 'cyan'
                        : rowData.missionTag == 'returning'
                        ? 'yellow'
                        : rowData.missionTag == 'ongoing'
                        ? 'green'
                        : rowData.missionTag == 'ended'
                        ? 'red'
                        : 'violet'
                    }`}
                  >
                    {rowData.missionTag == 'departure'
                      ? 'Departure'
                      : rowData.missionTag == 'returning'
                      ? 'Return'
                      : rowData.missionTag == 'ongoing'
                      ? 'Ongoing'
                      : rowData.missionTag == 'ended'
                      ? 'Ended'
                      : rowData.missionTag == 'departure_and_return'
                      ? 'Departure-Return'
                      : rowData.missionTag}
                  </Tag>
                );
              }}
            </Cell>
          </Column>

          <ColumnGroup header="Transportation Costs" width={200}>
            {/* {Array.from({ length: maxColumns }).map((_, index) => {
              return (
                <>
                  <Column key={index} width={200} align="center" resizable>
                    <HeaderCell>
                      {groupedData.find(row => row.allTransportationCosts?.[index])
                        ?.allTransportationCosts[index]?.type || 'Unknown Type'}
                    </HeaderCell>
                    <Cell>
                      {rowData => {
                        const costItem = rowData.allTransportationCosts?.[index];
                        const currency = currencies?.find(c => c._id === costItem?.currency);

                        return rowData.missionType == 'compound' &&
                          costItem &&
                          costItem.mission == rowData.subMissionId
                          ? `${costItem.cost} ${currency.name || ''}`
                          : costItem && !costItem.mission
                          ? `${costItem.cost} ${currency.name || ''}`
                          : '-';
                      }}
                    </Cell>
                  </Column>

                  {groupedData.find(row => row.allTransportationCosts?.[index])
                    ?.allTransportationCosts[index]?.type == 'ticket cost' && (
                    <Column key={index} width={200} align="center" resizable>
                      <HeaderCell>Class</HeaderCell>
                      <Cell>
                        {rowData => {
                          console.log('class', rowData.allTransportationCosts?.[index]);
                          return 'test';
                          // const costItem = rowData.allTransportationCosts?.[index];

                          // return costItem.class;
                        }}
                      </Cell>
                    </Column>
                  )}
                </>
              );
            })} */}

            {transportTypeCosts
              ?.filter(item => item != undefined)
              .map((type, index) => {
                return (
                  <Column key={index} width={200} align="center" resizable>
                    <HeaderCell>{type ? type : 'Unknown type'}</HeaderCell>

                    <Cell>
                      {rowData => {
                        const costItem = rowData.allTransportationCosts?.find(
                          item => item.type === type || item.comment === type
                        );
                        const currency = currencies?.find(c => c._id === costItem?.currency);

                        return rowData.missionType == 'compound' &&
                          costItem &&
                          costItem.mission == rowData.subMissionId
                          ? `${costItem?.cost} ${currency?.name || ''}`
                          : costItem && !costItem.mission
                          ? `${costItem?.cost} ${currency?.name || ''}`
                          : '-';
                      }}
                    </Cell>
                  </Column>
                );
              })}
            {/* <Column width={200} align="center" resizable>
              <HeaderCell>Class</HeaderCell>

              {rowData => {
                rowData?.allTransportationCosts?.map(item => {
                  item.type == 'ticket cost' && <Cell>{item?.class}</Cell>;
                });
              }}
            </Column> */}

            <Column width={200} align="center" resizable>
              <HeaderCell>Class</HeaderCell>
              <Cell>
                {rowData =>
                  rowData.allTransportationCosts?.length > 0
                    ? rowData.allTransportationCosts
                        .map(item => item.class)
                        .filter(Boolean)
                        .join(',')
                    : '-'
                }
              </Cell>
            </Column>

            <Column width={200} align="center" resizable>
              <HeaderCell>{t('Company')}</HeaderCell>
              <Cell>
                {rowData =>
                  rowData.companies?.length
                    ? rowData.companies
                        .map(company => company?.name)
                        .filter(Boolean)
                        .join(', ')
                    : '-'
                }
              </Cell>
            </Column>
            {currenciesTransport
              ?.filter(item => item != undefined)
              .map((currencyId, index) => {
                const currency = currencies?.find(c => c._id === currencyId);

                return (
                  <Column key={index} width={200} align="center" resizable>
                    <HeaderCell>
                      {currency ? 'Calculated cost in ' + currency.name : 'Unknown Currency'}
                    </HeaderCell>

                    <Cell>
                      {rowData => {
                        const costItem = rowData.transportationCosts.find(
                          item => item.currencyId === currencyId
                        );
                        return costItem?.cost ? `${costItem.cost} ${currency?.name || ''}` : '-';
                      }}
                    </Cell>
                  </Column>
                );
              })}
          </ColumnGroup>

          <ColumnGroup header="Accomodation Costs">
            {currenciesStay
              ?.filter(item => item != undefined)
              ?.map((currencyId, index) => {
                const currency = currencies?.find(c => c._id === currencyId);

                return (
                  <Column key={index} width={200} align="center" resizable>
                    <HeaderCell>
                      {currency ? 'Calculated cost in ' + currency.name : 'Unknown Currency'}
                    </HeaderCell>

                    <Cell>
                      {rowData => {
                        const costItem = rowData.stayCosts.find(
                          item => item.currencyId === currencyId
                        );
                        return costItem?.cost ? `${costItem.cost} ${currency?.name || ''}` : '-';
                      }}
                    </Cell>
                  </Column>
                );
              })}

            {currenciesStayEstimated
              ?.filter(item => item != undefined)
              ?.map((currencyId, index) => {
                const currency = currencies?.find(c => c._id === currencyId);

                return (
                  <Column key={index} width={200} align="center" resizable>
                    <HeaderCell>
                      {currency ? 'Estimated cost in ' + currency.name : 'Unknown Currency'}
                    </HeaderCell>

                    <Cell>
                      {rowData => {
                        const costItem = rowData.stayEstimated.find(
                          item => item.currencyId === currencyId
                        );
                        return costItem?.cost ? `${costItem.cost} ${currency?.name || ''}` : '-';
                      }}
                    </Cell>
                  </Column>
                );
              })}
          </ColumnGroup>

          <ColumnGroup header="Other Accomodation Costs">
            {currenciesOtherAccomodation
              ?.filter(item => item != undefined)
              ?.map((currencyId, index) => {
                const currency = currencies?.find(c => c._id === currencyId);

                return (
                  <Column key={index} width={200} align="center" resizable>
                    <HeaderCell>
                      {currency ? 'Calculated cost in ' + currency.name : 'Unknown Currency'}
                    </HeaderCell>

                    <Cell>
                      {rowData => {
                        const costItem = rowData.otherAccomodationCosts.find(
                          item => item.currencyId === currencyId
                        );
                        return costItem?.cost ? `${costItem.cost} ${currency?.name || ''}` : '-';
                      }}
                    </Cell>
                  </Column>
                );
              })}
          </ColumnGroup>
          <ColumnGroup header="Per Diem Costs">
            {currenciesPerdiems
              ?.filter(item => item != undefined)
              ?.map((currencyId, index) => {
                const currency = currencies?.find(c => c._id === currencyId);

                return (
                  <Column key={index} width={200} align="center" resizable>
                    <HeaderCell>
                      {currency ? 'Calculated cost in ' + currency.name : 'Unknown Currency'}
                    </HeaderCell>

                    <Cell>
                      {rowData => {
                        const costItem = rowData.perdiems.find(
                          item => item.currencyId === currencyId
                        );
                        return costItem?.cost ? `${costItem.cost} ${currency?.name || ''}` : '-';
                      }}
                    </Cell>
                  </Column>
                );
              })}
            {currenciesPerdiemsEstimated
              ?.filter(item => item != undefined)
              ?.map((currencyId, index) => {
                const currency = currencies?.find(c => c._id === currencyId);

                return (
                  <Column key={index} width={200} align="center" resizable>
                    <HeaderCell>
                      {currency ? 'Estimated cost in ' + currency.name : 'Unknown Currency'}
                    </HeaderCell>

                    <Cell>
                      {rowData => {
                        const costItem = rowData.perdiemsEstimated.find(
                          item => item.currencyId === currencyId
                        );
                        return costItem?.cost ? `${costItem.cost} ${currency?.name || ''}` : '-';
                      }}
                    </Cell>
                  </Column>
                );
              })}
          </ColumnGroup>
          <ColumnGroup header="Extra expenses Costs">
            <Column width={200} align="center" resizable>
              <HeaderCell>
                {'Calculated cost in ' + currencies
                  ? currencies?.find(c => c.name === 'EUR')?.name
                  : ''}
              </HeaderCell>

              <Cell>
                {rowData => {
                  return rowData.extraExpensesSum
                    ? `${rowData.extraExpensesSum} ${
                        currencies?.find(c => c.name === 'EUR')?.name || ''
                      }`
                    : '-';
                }}
              </Cell>
            </Column>
          </ColumnGroup>
          <ColumnGroup header="Invoices">
            <Column width={200} align="center" resizable>
              <HeaderCell>{t('Cost invoices in EUR')}</HeaderCell>

              <Cell>
                {rowData => {
                  return (
                    <Tag
                      title={t("Refund invoices")}
                      color={
                        rowData.billsCount?.uploaded > 0 &&
                        rowData.billsCount?.uploaded < rowData.billsCount?.total
                          ? 'orange'
                          : rowData.billsCount?.uploaded == 0
                          ? 'red'
                          : 'green'
                      }
                    >{`${rowData.billsCount?.uploaded} / ${rowData.billsCount?.total}`}</Tag>
                  );
                }}
              </Cell>
            </Column>
            <Column width={200} align="center" resizable>
              <HeaderCell>{t('Cost invoices in TND')}</HeaderCell>

              <Cell>
                {rowData => {
                  return (
                    // <p
                    //   style={{
                    //     color:
                    //       rowData.invoicesCount?.uploaded > 0 &&
                    //       rowData.invoicesCount?.uploaded < rowData.billsCount?.total
                    //         ? 'orange'
                    //         : rowData.invoicesCount?.uploaded == 0
                    //         ? 'red'
                    //         : 'green'
                    //   }}
                    // >
                    //   {`${rowData.invoicesCount?.uploaded} / ${rowData.invoicesCount?.total}`}
                    // </p>
                    <Tag
                      title="closing invoices"
                      color={
                        rowData.invoicesCount?.uploaded > 0 &&
                        rowData.invoicesCount?.uploaded < rowData.invoicesCount?.total
                          ? 'orange'
                          : rowData.invoicesCount?.uploaded == 0
                          ? 'red'
                          : 'green'
                      }
                    >{`${rowData.invoicesCount?.uploaded} / ${rowData.invoicesCount?.total}`}</Tag>
                  );
                }}
              </Cell>
            </Column>
          </ColumnGroup>
        </Table>
      </Panel>
    </>
  );
};

export default DataTable;
